var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.562 164.062H204.453L184.297 184.297L195.312 195.312L234.375 156.25L195.312 117.188L184.297 128.203L204.453 148.438H101.562V164.062Z",
    fill: "#00607D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.875 109.375V78.125C171.881 77.0968 171.684 76.0776 171.295 75.1257C170.906 74.1739 170.333 73.3081 169.609 72.5781L114.922 17.8906C114.192 17.1666 113.326 16.5937 112.374 16.2049C111.422 15.8161 110.403 15.6191 109.375 15.625H31.25C27.106 15.625 23.1317 17.2712 20.2015 20.2015C17.2712 23.1317 15.625 27.106 15.625 31.25V218.75C15.625 222.894 17.2712 226.868 20.2015 229.799C23.1317 232.729 27.106 234.375 31.25 234.375H156.25C160.394 234.375 164.368 232.729 167.299 229.799C170.229 226.868 171.875 222.894 171.875 218.75V203.125H156.25V218.75H31.25V31.25H93.75V78.125C93.75 82.269 95.3962 86.2433 98.3265 89.1736C101.257 92.1038 105.231 93.75 109.375 93.75H156.25V109.375H171.875ZM109.375 78.125V34.4531L153.047 78.125H109.375Z",
    fill: "#00607D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumento);
export default __webpack_public_path__ + "static/media/Documento.fbe9fc2afb54f3cf3168950f2d079673.svg";
export { ForwardRef as ReactComponent };